module.exports = __webpack_public_path__ + "static/media/bg-02@3x.90bb95c0.png";